export const WorkEligibilityText = {
  DOES_NOT_HAVE_AUTHORIZATION: 'No U.S. work authorization (self-reported)',
  HAS_AUTHORIZATION: 'Has U.S. work authorization (self-reported)',
  UNREPORTED_AUTHORIZATION: 'Work authorization not reported',
};
